module.exports = __webpack_public_path__ + "img/achievement_24.328b1482.png";